import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import axiosMain from "../../../../../http/axios/axios_main";
import CustomToast from "../../../../../components/Toast";
import { useAuctionDetail } from "../../../../../components/common/AunctioneerDeteailProvider";
import axios from "axios";
import { useDispatch } from "react-redux";
import { fetchSampleShortageListRequest } from "../../../../../store/actions";
import { useLoader } from "../../../../../components/common/Loder/Loder";
import { Table, Toast } from "react-bootstrap";

const validationSchema = Yup.object().shape({
  InspectionChgs: Yup.string()
    .required("Please enter appropriate Inspection Charges.")
    .test(
      "is-numeric-or-float",
      "Invalid value for InspectionChgs",
      (value) => {
        // Regular expression to allow numeric and float values
        return /^[0-9]+(\.[0-9]+)?$/.test(value);
      }
    ),
  LOTNO: Yup.string().required("LOTNO is required"),
  PACKAGENO: Yup.string().required("PACKAGENO is required"),
  ReInspectionChgs: Yup.string()
    .required("ReInspectionChgs is required")
    .test(
      "is-numeric-or-float",
      "Please enter appropriate Re-inspection Charges.",
      (value) => {
        // Regular expression to allow numeric and float values
        return /^[0-9]+(\.[0-9]+)?$/.test(value);
      }
    ),
  SAMPLEWT: Yup.string()
    .required("SAMPLEWT is required")
    .test(
      "is-numeric-or-float",
      "Please enter appropriate Sample Weight.",
      (value) => {
        // Regular expression to allow numeric and float values
        return /^[0-9]+(\.[0-9]+)?$/.test(value);
      }
    ),
  SHORTWT: Yup.string()
    .required("SHORTWT is required")
    .test(
      "is-numeric-or-float",
      "Please enter appropriate Short Weight.",
      (value) => {
        // Regular expression to allow numeric and float values
        return /^[0-9]+(\.[0-9]+)?$/.test(value);
      }
    ),
});

const MenualForm = ({
  rows,
  setRows,
  handleSubmit,
  isDisable,
  isEdit,
  seasonpass,
  saleNopass,
  setExpandedTab,
  getSampledata, dataRow
}) => {
  const {
    auctionDetailId,
    auctionCenterUserId,
    auctionCenterId,
    userId,
    roleCode,
    auction,
    auctionTypeMasterCode,
  } = useAuctionDetail();
  const { openLoader, closeLoader } = useLoader();

  const [selectedRows, setSelectedRows] = useState([]);
  const baseUrlEng =
    auction === "ENGLISH" ? "EnglishAuctionSampleShortage" : "SampleShortage";
  console.log(baseUrlEng, "baseUrlEng");
  const [viewDataList, setViewDataList] = useState([
    // {
    //   LotNo: "Sach123AHM20231710-S ",
    //   categoryId: 10131,
    //   categoryName: "Crush Tear And Curl",
    //   gradeId: 4,
    //   gradeName: "Grade3",
    //   inspectionCharges: 10,
    //   invoiceId: 0,
    //   invoiceNo: "TEST11152",
    //   markId: 40,
    //   markName: "Orange",
    //   netKgs: 53,
    //   packageNo: "10-20",
    //   reInspectionCharges: 10,
    //   saleNo: 17,
    //   sampleWeight: "54",
    //   season: "2023",
    //   shortWeight: 2,
    //   shortWeightId: 0,
    //   teaTypeId: 85,
    //   teaTypeName: "Leaf",
    //   totalPackages: 11,
    //   totalSampleQty: 5,
    //   totalShortQty: 2,
    // },
    // {
    //   LotNo: "Sach123AHM20231710-S ",
    //   categoryId: 10131,
    //   categoryName: "Crush Tear And Curl",
    //   gradeId: 4,
    //   gradeName: "Grade3",
    //   inspectionCharges: 10,
    //   invoiceId: 0,
    //   invoiceNo: "TEST11152",
    //   markId: 40,
    //   markName: "Orange",
    //   netKgs: 53,
    //   packageNo: "10-20",
    //   reInspectionCharges: 10,
    //   saleNo: 17,
    //   sampleWeight: "54",
    //   season: "2023",
    //   shortWeight: 2,
    //   shortWeightId: 0,
    //   teaTypeId: 85,
    //   teaTypeName: "Leaf",
    //   totalPackages: 11,
    //   totalSampleQty: 5,
    //   totalShortQty: 2,
    // },
  ]);
  console.log(viewDataList, "viewDataList");
  const viewData = useSelector(
    (state) => state?.sampleShortageReducer?.data?.responseData
  );
  const newww = useSelector((state) => state?.sampleShortageReducer);

  const isSelected = (index) => selectedRows.includes(index);
  console.log(newww, "newww");
  console.log(viewData, "viewData");
  const dispatch = useDispatch();

  const [columns, setColumns] = useState([
    { id: "packageNo", label: "Package No" },
    { id: "sampleWeight", label: "Sample Weight" },
    { id: "shortWeight", label: "Short Weight" },
    { id: "inspectionCharges", label: "Inspection Charges" },
    { id: "reInspectionCharges", label: "Re-Inspection Charges" },
  ]);
  // useEffect(() => {
  //   // setViewDataList([]);
  //   if(viewDataList.lenght === 0){
  //     setViewDataList([
  //       ...viewDataList,
  //       viewDataList
  //         .map((ele) => ({
  //           ...ele,
  //           inspectionCharges: 0,
  //           packageNo: 0,
  //           reInspectionCharges: 0,
  //           sampleWeight: 0,
  //           shortWeight: 0,
  //           shortWeightId: null,
  //           isDisable: false,
  //         }))
  //         .at(0),
  //     ]);
  //   }
  // }, [viewDataList]);

  console.log(isDisable, "isDisableisDisable");
  const formik = useFormik({
    initialValues: {
      InspectionChgs: "",
      LOTNO: "",
      PACKAGENO: "",
      ReInspectionChgs: "",
      SAMPLEWT: "",
      SHORTWT: "",
    },
    validationSchema,
    onSubmit: async (values, actions) => {
      // Call the API to create data
      setRows([...rows, values]);
      // let updatedData = rows;

      // //   console.log(values, "rowsrows");
      // if (isEdit) {

      // }
    },
  });
  useEffect(() => {
    if (viewData?.length > 0) {
      let data = viewData.map((ele) => {
        return {
          ...ele,
          sampleWeight: ele.sampleWeight === null ? 0 : ele.sampleWeight,
          shortWeight: ele.shortWeight === null ? 0 : ele.shortWeight,
          inspectionCharges:
            ele.inspectionCharges === null ? 0 : ele.inspectionCharges,
          reInspectionCharges:
            ele.reInspectionCharges === null ? 0 : ele.reInspectionCharges,
          isDisable:
            ele.packageNo === null || ele.packageNo === 0 ? false : true,
        };
      });
      setViewDataList(data);
    } else setViewDataList([]);

    if (isEdit) {
      formik.setFieldValue("PACKAGENO", viewData?.at(0)?.invPackageNo);
      formik.setFieldValue("SAMPLEWT", viewData?.at(0)?.sampleWeight);
      formik.setFieldValue("SHORTWT", viewData?.at(0)?.shortWeight);
      formik.setFieldValue(
        "InspectionChgs",
        viewData?.at(0)?.inspectionCharges
      );
      formik.setFieldValue(
        "ReInspectionChgs",
        viewData?.at(0).reInspectionCharges
      );
    } else {
      formik.setFieldValue("PACKAGENO", "");
    }
  }, [viewData]);
  console.log(viewDataList, "viewDataListviewDataList");

  /*----------Add Row----------*/

  function addnewRow(e) {
    e.preventDefault();
    setViewDataList([
      ...viewDataList,
      viewDataList
        .map((ele) => ({
          ...ele,
          inspectionCharges: 0,
          packageNo: 0,
          reInspectionCharges: 0,
          sampleWeight: 0,
          shortWeight: 0,
          shortWeightId: null,
          isDisable: false,
        }))
        .at(0),
    ]);
  }

  /*---------Add Row-----------*/

  const sampleshortage = [
    // {
    //   name: "select",
    //   title: "Select",
    //   getCellValue: ({ ...row }) => <AWRCheckBox data={row} />,
    // },
    {
      name: "season",
      title: "Season",
    },
    {
      name: "saleNo",
      title: "Sale No",
    },
    // {
    //   name: "markName",
    //   title: "Mark",
    // },
    {
      name: "LotNo",
      title: "Lot No",
    },
    {
      name: "teaTypeName",
      title: "Tea Type",
    },
    {
      name: "invoiceNo",
      title: "Invoice No",
    },
    {
      name: "markName",
      title: "Mark",
    },
    {
      name: "gradeName",
      title: "Grade",
    },

    {
      name: "categoryName",
      title: "Category",
    },
    {
      name: "packageNo",
      title: "Packages No.",
    },
    {
      name: "totalPackages",
      title: "No Of Packages",
    },
    {
      name: "netKgs",
      title: "Net Weight",
    },
    // {
    //   name: "totalSampleQty",
    //   title: "Total Sample Qty",
    // },
    {
      name: "sampleWeight",
      title: "Sample Weight",
    },
    // {
    //   name: "totalShortQty",
    //   title: "Total Short Qty",
    // },
    {
      name: "shortWeight",
      title: "Short Weight",
    },
    {
      name: "inspectionCharges",
      title: "Inspection Charges",
    },
    {
      name: "reInspectionCharges",
      title: "Re-Inspection Charges",
    },
  ];

  // const handleInputChange = (event, name) => {
  //   const newData = viewDataList.map((item) => {
  //     if (item.name === name) {
  //       return { ...item, lotno: event.target.value };
  //     }
  //     return item;
  //   });
  //   setViewDataList(newData);
  // };

  const handleInputChange = (event, rowIndex, fieldName) => {
    const newValue = event.target.value;
    setViewDataList((prevData) => {
      const newData = [...prevData];
      newData[rowIndex][fieldName] = newValue;
      return newData;
    });
  };

  const handlePrintData = () => {
    let data = viewDataList.map((ele) => {
      let result = {
        LotNo: ele.LotNo,
        packageNo: ele.packageNo,
        sampleWeight:
          parseFloat(ele.sampleWeight) === null
            ? 0
            : parseFloat(ele.sampleWeight),
        shortWeight:
          parseFloat(ele.shortWeight) === null
            ? 0
            : parseFloat(ele.shortWeight),
        inspectionCharges:
          parseFloat(ele.inspectionCharges) === null
            ? 0
            : parseFloat(ele.inspectionCharges),
        reInspectionCharges:
          parseFloat(ele.reInspectionCharges) === null
            ? 0
            : parseFloat(ele.reInspectionCharges),
        isActive: true,
        createdBy: userId, //auctioner
        updatedBy: userId, //auctioner
        auctionCenterId: auctionCenterId,

        // shortWeightId: parseInt(
        //   ele.shortWeightId === "" ? 0 : ele.shortWeightId
        // ),
        season: seasonpass?.toString(), //ele.season?.toString(),
        saleNo: parseInt(saleNopass === "" ? 0 : saleNopass), //parseInt(ele.saleNo === "" ? 0 : ele.saleNo),
      };
      return result;
    });
    let ret = false;
    data.map((ele) => {
      if (
        ele.packageNo === null ||
        ele.packageNo === "0" ||
        ele.packageNo === ""
      ) {
        ret = true;
      }
    });
    if (ret) {
      CustomToast.error(
        "Please enter valid Package No. in lot no.  " +
        data
          .map((ele) =>
            ele.packageNo === null ||
              ele.packageNo === "0" ||
              ele.packageNo === ""
              ? ele.LotNo
              : ""
          )
          ?.filter((ele) => ele !== "")
          .join(",")
      );
      return false;
    }
    // if (
    //   data.filter(
    //     (ele) =>
    //       isNaN(ele.sampleWeight) ||
    //       ele.sampleWeight === "0" ||
    //       ele.sampleWeight === ""
    //   ).length > 0
    // ) {
    //   CustomToast.error("Please Fill Sample Weight.");
    //   return false;
    // }
    if (
      data.filter(
        (ele) => ele.packageNo && /^[0-9]+$/.test(ele.packageNo) === false
      ).length > 0
      // data.filter((ele) => ele.packageNo?.toString()?.includes("."))?.length >
      //   0 ||
      // data.filter((ele) => ele.packageNo && /^[A-Za-z]+$/.test(ele.packageNo))
      //   ?.length > 0
    ) {
      CustomToast.error("Please enter valid Package No.");

      return false;
    }
    if (
      viewDataList.filter(
        (ele) =>
          isNaN(parseFloat(ele.sampleWeight)) ||
          ele.sampleWeight?.toString().includes("-") ||
          /^[0-9]+(\.[0-9]+)?$/.test(ele.sampleWeight) === false
      ).length > 0
    ) {
      CustomToast.error("Please enter Sample Weight");

      return false;
    }
    if (
      viewDataList.filter(
        (ele) =>
          isNaN(parseFloat(ele.shortWeight)) ||
          ele.shortWeight?.toString().includes("-") ||
          /^[0-9]+(\.[0-9]+)?$/.test(ele.shortWeight) === false
      ).length > 0
    ) {
      CustomToast.error("Please enter Short Weight");

      return false;
    }

    if (
      viewDataList.filter(
        (ele) =>
          isNaN(parseFloat(ele.inspectionCharges)) ||
          ele.inspectionCharges?.toString().includes("-") ||
          /^[0-9]+(\.[0-9]+)?$/.test(ele.inspectionCharges) === false
      ).length > 0
    ) {
      CustomToast.error("Please enter Inspection Charges");

      return false;
    }

    if (
      viewDataList.filter(
        (ele) =>
          isNaN(parseFloat(ele.reInspectionCharges)) ||
          ele.reInspectionCharges?.toString().includes("-") ||
          /^[0-9]+(\.[0-9]+)?$/.test(ele.reInspectionCharges) === false
      ).length > 0
    ) {
      CustomToast.error("Please enter Re-Inspection Charges");

      return false;
    }
    let fileData = data.map((ele) => {
      let data = {
        LotNo: ele.LotNo?.toString(),
        packageNo: ele.packageNo?.toString(),
        createdBy: userId,
        season: seasonpass?.toString(), //ele.season?.toString(),
        saleNo: parseInt(saleNopass === "" ? 0 : saleNopass), //parseInt(ele.saleNo === "" ? 0 : ele.saleNo),
        auctionCenterId: auctionCenterId,
      };
      return data;
    });
    openLoader();
    axiosMain
      .post(`/preauction/${baseUrlEng}/CheckPackageNoByLotNo?season=` + seasonpass + "&saleNo=" + saleNopass, fileData)
      .then((res) => {
        if (res.data.statusCode === 200) {
          // CustomToast.success(res.data.message);
          axiosMain
            .post(
              `/preauction/${baseUrlEng}/UploadSampleShortage?role=` +
              roleCode +
              "&validateAction=submit&dataFlag=Menual&season=" + seasonpass + "&saleNo=" + saleNopass,
              data
            )
            // axios
            //   .post(
            //     "http://192.168.101.178:5080/preauction/SampleShortage/UploadSampleShortage?role=" +
            //       roleCode,
            //     data
            //   )
            .then((res) => {
              if (res.data.statusCode === 200) {
                const data = {
                  pageNumber: 1,
                  pageSize: 10,
                  season: seasonpass?.toString(), //ele.season?.toString(),
                  saleNo: parseInt(saleNopass === "" ? 0 : saleNopass), //parseInt(ele.saleNo === "" ? 0 : ele.saleNo),
                  markId: 0,
                  // === null ? parseInt(values.mark) : 0
                  auctioneerId: userId, //auctioner
                  auctionCenterId: auctionCenterId,
                };
                CustomToast.success(res.data.message);
                // dispatch(
                //   fetchSampleShortageListRequest(data, roleCode, baseUrlEng)
                // );
                setExpandedTab("panel1");
                formik.resetForm();
                getSampledata();
              } else {
                closeLoader();
                CustomToast.error(res.data.message);
              }
              // closeLoader();
            });
          // .catch((error) => CustomToast.error(error.data.errors));
        } else {
          closeLoader();
          CustomToast.error(res.data.message);
        }
      });

    // console.log(data);
  };
  const sampleshortageUpdate = [
    // {
    //   name: "select",
    //   title: "Select",
    //   getCellValue: ({ ...row }) => <AWRCheckBox data={row} />,
    // },
    // {
    //   name: "season",
    //   title: "Season",
    // },
    // {
    //   name: "saleNo",
    //   title: "Sale No",
    // },
    // {
    //   name: "markName",
    //   title: "Mark",
    // },
    {
      name: "LotNo",
      title: "Lot No",
    },
    {
      name: "markName",
      title: "Mark",
    },
    {
      name: "teaTypeName",
      title: "Tea Type",
    },
    {
      name: "invoiceNo",
      title: "Invoice No",
    },
    {
      name: "categoryName",
      title: "Category",
    },
    {
      name: "netKgs",
      title: "Net Weight",
    },
    {
      name: "gradeName",
      title: "Grade",
    },

    {
      name: "invPackageNo",
      title: "Package No",
    },
    // {
    //   name: "packageNo",
    //   title: "packageNo",
    // },
    // {
    //   name: "shortWeight",
    //   title: "Short Weight",
    // },
    // {
    //   name: "inspectionCharges",
    //   title: "Inspection Charges",
    // },
    // {
    //   name: "reInspectionCharges",
    //   title: "Re-Inspection Charges",
    // },
  ];

  const fnRemoverow = () => {
    openLoader();
    // const isSelected = (index) => selectedRows.includes(index);
    const selected = viewDataList
      .map((item, index) =>
        selectedRows.includes(index) ? item.shortWeightId : null
      )
      .filter((im) => im !== null && im !== 0)
      .join(",");
    // debugger;
    console.log(selected);
    // debugger;
    if (selected === "") {
      if (
        viewDataList.filter((item, index) => !selectedRows.includes(index))
          .length === 0
      ) {
        setViewDataList([
          {
            ...viewDataList
              .filter((item, index) => selectedRows.includes(index))
              ?.at(0),
            inspectionCharges: 0,
            packageNo: 0,
            reInspectionCharges: 0,
            sampleWeight: 0,
            shortWeight: 0,
            shortWeightId: null,
            isDisable: false,
          },
        ]);
      } else {
        setViewDataList(
          viewDataList.filter((item, index) => !selectedRows.includes(index))
        );
      }
      closeLoader();
    } else {
      axiosMain
        .post(`/preauction/${baseUrlEng}/DeleteSampleShortage`, {
          sampleShortageIds: selected,
          updatedBy: userId,
          auctionCenterId: auctionCenterId,
        })
        .then((res) => {
          // formik.handleSubmit();
          if (res.data.statusCode === 200) {
            // formik.handleSubmit();
            // openLoader();
            // CustomToast.success(res.data.message);
            if (
              viewDataList.filter(
                (item, index) => !selectedRows.includes(index)
              ).length === 0
            ) {
              setViewDataList([
                {
                  ...viewDataList
                    .filter((item, index) => selectedRows.includes(index))
                    ?.at(0),
                  inspectionCharges: 0,
                  packageNo: 0,
                  reInspectionCharges: 0,
                  sampleWeight: 0,
                  shortWeight: 0,
                  shortWeightId: null,
                  isDisable: false,
                },
              ]);
            } else {
              setViewDataList(
                viewDataList.filter(
                  (item, index) => !selectedRows.includes(index)
                )
              );
            }
            CustomToast.success(res.data.message);
          } else {
            CustomToast.error(res.data.message);
          }
          closeLoader();
        })
        .catch((error) => {
          closeLoader();
          // Handle errors here
        });
    }
    setSelectedRows([]);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      // const allRowIds = rows.map((row, index) => index);
      const allRowIds = viewDataList.map((row, index) => index);
      setSelectedRows(allRowIds);
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (index) => {
    if (selectedRows.includes(index)) {
      setSelectedRows(selectedRows.filter((i) => i !== index));
    } else {
      setSelectedRows([...selectedRows, index]);
    }
  };

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("dragIndex", index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, dropIndex) => {
    const dragIndex = e.dataTransfer.getData("dragIndex");
    const updatedColumns = [...columns];
    const draggedColumn = updatedColumns.splice(dragIndex, 1)[0];
    updatedColumns.splice(dropIndex, 0, draggedColumn);
    setColumns(updatedColumns);
  };

  return (
    <form onSubmit={formik.handleSubmit}>

      {/* {viewDataList?.length > 0 && isDisable
          ? sampleshortage?.map((key, index) => (
            <div key={key.name} className="col-xl-2 col-lg-2 col-md-4">
              <label>{key.title}</label>
              <br />
              <input
                className="form-control"
                type="text"
                value={viewDataList?.at(0)[key?.name] === null ? "" : viewDataList?.at(0)[key?.name]}
                // value={viewDataList[key.name]}
                // onChange={(e) => handleInputChange(e, key)}
                disabled
              />
            </div>
          ))
          : ""} */}
      {viewDataList?.length > 0 && isDisable ?
        <>
          <div className="row">
            <div className="col-xl-2 col-lg-2 col-md-4">
              <label>Season</label>
              <br />
              <input
                type="text"
                value={seasonpass}
                // value={viewDataList[key.name]}
                // onChange={(e) => handleInputChange(e, key)}
                disabled
              />
            </div>
            <div className="col-xl-2 col-lg-2 col-md-4">
              <label>Sale No</label>
              <br />
              <input
                type="text"
                value={saleNopass}
                // value={viewDataList[key.name]}
                // onChange={(e) => handleInputChange(e, key)}
                disabled
              />
            </div>
            {sampleshortageUpdate?.map((key, index) => (
              <div key={key.name} className="col-xl-2 col-lg-2 col-md-4">
                <label>{key.title}</label>
                <br />
                <input
                  type="text"
                  value={viewDataList.at(0)[key.name]}
                  // value={viewDataList[key.name]}
                  // onChange={(e) => handleInputChange(e, key)}
                  disabled
                />
              </div>
            ))}
          </div>

          <br />
          <div className="TableBox normal-table">
            <Table
              striped
              // bordered
              hover
              responsive
              className="resizable-columns-table border-0"
            >
              <thead>
                <tr>

                  {/* <th>Package No</th>
                  <th>Sample Weight</th>
                  <th>Short Weight</th>
                  <th>Inspection Charges</th>
                  <th>Re-Inspection Charges</th> */}
                  {columns.map((column, index) => (
                    <th
                      key={index}
                      draggable
                      onDragStart={(e) => handleDragStart(e, index)}
                      onDragOver={handleDragOver}
                      onDrop={(e) => handleDrop(e, index)}
                      style={{ width: "200px" }}
                    >
                      <div className="resizable-columns"> {column.label}</div>
                    </th>
                  ))}
                  {/* <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {viewDataList.map((item, index) => (
                  <tr key={index}>

                    {columns.map((colId) => {
                      return (
                        <>
                          {colId.id === "packageNo" && (
                            <td>
                              <input
                                type="text"
                                value={
                                  item.packageNo === null ? 0 : item.packageNo
                                }
                                disabled
                                onChange={(event) =>
                                  handleInputChange(event, index, "packageNo")
                                }
                                className="w-100"

                              />
                            </td>
                          )}
                          {colId.id === "sampleWeight" && (
                            <td>
                              <input
                                type="text"
                                value={
                                  item.sampleWeight === null
                                    ? 0
                                    : item.sampleWeight
                                }
                                disabled
                                className="w-100"
                                onChange={(event) =>
                                  handleInputChange(
                                    event,
                                    index,
                                    "sampleWeight"
                                  )
                                }
                              />
                            </td>
                          )}
                          {colId.id === "shortWeight" && (
                            <td>
                              <input
                                type="text"
                                value={
                                  item.shortWeight === null
                                    ? 0
                                    : item.shortWeight
                                }
                                disabled
                                className="w-100"
                                onChange={(event) =>
                                  handleInputChange(event, index, "shortWeight")
                                }
                              />
                            </td>
                          )}
                          {colId.id === "inspectionCharges" && (
                            <td>
                              <input
                                type="text"
                                value={
                                  item.inspectionCharges === null
                                    ? 0
                                    : item.inspectionCharges
                                }
                                disabled
                                className="w-100"
                                onChange={(event) =>
                                  handleInputChange(
                                    event,
                                    index,
                                    "inspectionCharges"
                                  )
                                }
                              />
                            </td>
                          )}
                          {colId.id === "reInspectionCharges" && (
                            <td>
                              <input
                                type="text"
                                value={
                                  item.reInspectionCharges === null
                                    ? 0
                                    : item.reInspectionCharges
                                }
                                disabled
                                className="w-100"
                                onChange={(event) =>
                                  handleInputChange(
                                    event,
                                    index,
                                    "reInspectionCharges"
                                  )
                                }
                              />
                            </td>
                          )}
                        </>
                      );
                    })}
                  </tr>
                ))}
                <tr className="border-0">
                  <td className="border-0"></td>
                  <td className="border-0">
                    <b>Total Sample Weight : {dataRow?.totalsampleWeight}</b>

                  </td>
                  <td className="border-0">
                    <b>Total Short Weight : {dataRow?.totalshortWeight}</b>

                  </td>
                  <td className="border-0">
                    <b>Total Inspection charges : {dataRow?.inspectionCharges}</b>

                  </td>
                  <td className="border-0">
                    <b>Total Re-Inspection Changes : {dataRow?.reInspectionCharges}</b>

                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          {/* <div className="row" style={{ marginLeft: "20.5rem", marginRight: "0" }}>
            <div className="col-lg-3 p-1">
            </div>
            <div className="col-lg-3 p-1">
            </div>
            <div className="col-lg-3 p-1">
            </div>
            <div className="col-lg-3 p-1">
            </div>
          </div> */}

        </> : ""}

      {viewDataList?.length > 0 && isEdit ? (
        <>
          <div className="row">
            <div className="col-xl-2 col-lg-2 col-md-4">
              <label>Season</label>
              <br />
              <input
                type="text"
                value={seasonpass}
                // value={viewDataList[key.name]}
                // onChange={(e) => handleInputChange(e, key)}
                disabled
              />
            </div>
            <div className="col-xl-2 col-lg-2 col-md-4">
              <label>Sale No</label>
              <br />
              <input
                type="text"
                value={saleNopass}
                // value={viewDataList[key.name]}
                // onChange={(e) => handleInputChange(e, key)}
                disabled
              />
            </div>
            {sampleshortageUpdate?.map((key, index) => (
              <div key={key.name} className="col-xl-2 col-lg-2 col-md-4">
                <label>{key.title}</label>
                <br />
                <input
                  type="text"
                  value={viewDataList.at(0)[key.name]}
                  // value={viewDataList[key.name]}
                  // onChange={(e) => handleInputChange(e, key)}
                  disabled
                />
              </div>
            ))}
          </div>
          <div className="mb-5">
            <button
              type="button"
              className="SubmitBtn"
              onClick={fnRemoverow}
              disabled={selectedRows.length > 0 ? false : true}
            >
              Remove
            </button>
            <button
              type="button"
              className="btn SubmitBtn"
              onClick={addnewRow}
              style={{ float: "inline-end" }}
            >
              Add Row
            </button>
          </div>
          <br />
          <div className="TableBox normal-table">
            <Table
              striped
              // bordered
              hover
              responsive
              className="resizable-columns-table border-0"
            >
              <thead>
                <tr>
                  <th
                    style={{
                      position: "sticky",
                      // left: status?.toString() === "0" ? "0px" : "30px",
                      background: "#fff",
                      zIndex: 10,
                      borderRight: "1px solid #ddd",
                      padding: "10px",
                      resize: "none",
                      width: "20px",

                    }}
                  >
                    <input
                      type="checkbox"
                      onChange={handleSelectAll}
                      checked={
                        selectedRows?.length === 0
                          ? false
                          : selectedRows?.length === viewDataList?.length
                      }
                      className="ms-0"
                    // disabled={
                    //   selectedRows?.length === 0
                    //     ? false
                    //     : selectedRows?.length === viewDataList?.length
                    // }
                    />
                  </th>
                  {/* <th>Package No</th>
                  <th>Sample Weight</th>
                  <th>Short Weight</th>
                  <th>Inspection Charges</th>
                  <th>Re-Inspection Charges</th> */}
                  {columns.map((column, index) => (
                    <th
                      key={index}
                      draggable
                      onDragStart={(e) => handleDragStart(e, index)}
                      onDragOver={handleDragOver}
                      onDrop={(e) => handleDrop(e, index)}
                      style={{ width: "200px" }}
                    >
                      <div className="resizable-columns"> {column.label}</div>
                    </th>
                  ))}
                  {/* <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {viewDataList.map((item, index) => (
                  <tr key={index}>
                    <td
                      style={{
                        position: "sticky",
                        // left: status?.toString() === "0" ? "0px" : "30px",
                        background: "#fff",
                        zIndex: 10,
                        borderRight: "1px solid #ddd",
                        padding: "10px",
                        resize: "none",
                        width: "340px",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={isSelected(index)}
                        onChange={() => handleRowSelect(index)}
                        // disabled={item.shortWeightId === 0}
                        className="w-100"
                      />
                    </td>
                    {columns.map((colId) => {
                      return (
                        <>
                          {colId.id === "packageNo" && (
                            <td>
                              <input
                                type="text"
                                value={
                                  item.packageNo === null ? 0 : item.packageNo
                                }
                                onChange={(event) =>
                                  handleInputChange(event, index, "packageNo")
                                }
                                className="w-100"
                                disabled={
                                  // viewData?.at(index)?.packageNo === null ||
                                  // item.packageNo === 0
                                  //   ? false
                                  //   : true
                                  item.isDisable
                                }
                              />
                            </td>
                          )}
                          {colId.id === "sampleWeight" && (
                            <td>
                              <input
                                type="text"
                                value={
                                  item.sampleWeight === null
                                    ? 0
                                    : item.sampleWeight
                                }
                                className="w-100"
                                onChange={(event) =>
                                  handleInputChange(
                                    event,
                                    index,
                                    "sampleWeight"
                                  )
                                }
                              />
                            </td>
                          )}
                          {colId.id === "shortWeight" && (
                            <td>
                              <input
                                type="text"
                                value={
                                  item.shortWeight === null
                                    ? 0
                                    : item.shortWeight
                                }
                                className="w-100"
                                onChange={(event) =>
                                  handleInputChange(event, index, "shortWeight")
                                }
                              />
                            </td>
                          )}
                          {colId.id === "inspectionCharges" && (
                            <td>
                              <input
                                type="text"
                                value={
                                  item.inspectionCharges === null
                                    ? 0
                                    : item.inspectionCharges
                                }
                                className="w-100"
                                onChange={(event) =>
                                  handleInputChange(
                                    event,
                                    index,
                                    "inspectionCharges"
                                  )
                                }
                              />
                            </td>
                          )}
                          {colId.id === "reInspectionCharges" && (
                            <td>
                              <input
                                type="text"
                                value={
                                  item.reInspectionCharges === null
                                    ? 0
                                    : item.reInspectionCharges
                                }
                                className="w-100"
                                onChange={(event) =>
                                  handleInputChange(
                                    event,
                                    index,
                                    "reInspectionCharges"
                                  )
                                }
                              />
                            </td>
                          )}
                        </>
                      );
                    })}

                    {/* <td>
                      <button
                        type="button"
                        className="SubmitBtn"
                        onClick={() => {
                          setViewDataList(
                            viewDataList?.filter(
                              (ele, indexs) => indexs !== index
                            )
                          );
                        }}
                        disabled={
                          // viewData?.at(index)?.packageNo === null ||
                          // item.packageNo === 0
                          //   ? false
                          //   : true
                          item.isDisable || viewDataList.length === 1
                        }
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td> */}
                  </tr>
                ))}
                <tr className="border-0">
                  <td className="border-0"></td>
                  <td className="border-0"></td>
                  <td className="border-0">
                    <b>Total Sample Weight :
                      {
                        viewDataList?.reduce((countttt, ele) => {
                          const shortWeight = parseFloat(isNaN(ele?.sampleWeight) || ele?.sampleWeight === null ? 0 : parseFloat(ele?.sampleWeight).toFixed(2));
                          return isNaN(countttt) ? 0 : countttt + (isNaN(shortWeight) ? 0 : shortWeight);
                        }, 0).toFixed(2)
                      }
                    </b>

                  </td>
                  <td className="border-0">
                    <b>Total Short Weight : {
                      viewDataList?.reduce((countttt, ele) => {
                        const shortWeight = parseFloat(isNaN(ele?.shortWeight) || ele?.shortWeight === null ? 0 : parseFloat(ele?.shortWeight).toFixed(2));
                        return isNaN(countttt) ? 0 : countttt + (isNaN(shortWeight) ? 0 : shortWeight);
                      }, 0).toFixed(2)
                    }</b>

                  </td>
                  <td className="border-0">
                    <b>Total Inspection charges : {
                      viewDataList?.reduce((countttt, ele) => {
                        const shortWeight = parseFloat(isNaN(ele?.inspectionCharges) || ele?.inspectionCharges === null ? 0 : parseFloat(ele?.inspectionCharges).toFixed(2));
                        return isNaN(countttt) ? 0 : countttt + (isNaN(shortWeight) ? 0 : shortWeight);
                      }, 0).toFixed(2)
                    }</b>

                  </td>
                  <td className="border-0">
                    <b>Total Re-Inspection Changes : {
                      viewDataList?.reduce((countttt, ele) => {
                        const reInspectionCharges = parseFloat(isNaN(ele?.reInspectionCharges) || ele?.reInspectionCharges === null ? 0 : parseFloat(ele?.reInspectionCharges).toFixed(2));
                        return isNaN(countttt) ? 0 : countttt + (isNaN(reInspectionCharges) ? 0 : reInspectionCharges);
                      }, 0).toFixed(2)
                    }</b>

                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </>
      ) : (
        ""
      )}
      {isDisable ? (
        ""
      ) : isEdit ? (
        <button
          type="button"
          className="btn SubmitBtn"
          onClick={handlePrintData}
        >
          Update
        </button>
      ) : (
        <>
          {" "}
          {/* <button type="submit">Add</button>
          <button
            type="button"
            onClick={() => {
              formik.resetForm();
              handleSubmit();
            }}
          >
            Create
          </button> */}
        </>
      )}
    </form>
  );
};

export default MenualForm;
